import { SxProps, Theme } from '@mui/material';

const styles = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#f6f8f7',
    color: '#1f2a24',
    py: { xs: 3, md: 5 },
  } as SxProps<Theme>,

  header: {
    mb: 3,
  } as SxProps<Theme>,

  panel: {
    backgroundColor: '#fff',
    border: '1px solid #dfe7e2',
    borderRadius: 2,
    p: { xs: 2, md: 3 },
  } as SxProps<Theme>,

  fieldGrid: {
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      md: 'repeat(2, minmax(0, 1fr))',
    },
    gap: 2,
  } as SxProps<Theme>,

  taskRow: {
    border: '1px solid #dfe7e2',
    borderRadius: 1,
    p: 1.5,
  } as SxProps<Theme>,
};

export default styles;
